import { dbridge } from '@didi/driver-bridge'
import store from '../store'
import { REALNAME_VERIFY_STATUS, TICKET, REALNAME_USER_INFO, USER_HAS_REAL_NAME } from '../store/mutation-types'
import { oMegaData, name_auth_omega_summary } from 'common-js/omega'
import { fetchPost } from 'common-js/api/http'
import { apolloInfo } from 'common-js/util'
import { urlObj } from '../config/url'
import auth from 'common-js/api/auth'
import { defaultBiz } from '../config/utils'
import { is } from 'common-js/util/env'
import url from 'common-js/util/url'
import { CODE_TYPE } from 'common-js/util/const'

export function showConfirm (_ctr, opt) {
  _ctr.$createDialog({
    type: 'confirm',
    title: opt.title,
    icon: 'cubeic-important',
    content: opt.content,
    confirmBtn: {
      text: opt.confirmText,
      active: true,
      disabled: false,
      href: 'javascript:;'
    },
    cancelBtn: {
      text: opt.cancelText,
      active: false,
      disabled: false,
      href: 'javascript:;'
    },
    onConfirm: opt.onConfirm,
    onCancel: opt.onCancel
  }).show()
}
export function toast(ctr, opt = {time: 0}) {
  const toastInstance = ctr.$createToast({
    txt: opt.txt || '加载中',
    type: opt.type || 'loading',
    time: opt.time,
    onTimeout: opt.onTimeout
  })
  toastInstance.show()
  return toastInstance
}
export function showAlert(ctr, opt = {}) {
  ctr.$createDialog({
    type: 'alert',
    title: opt.title,
    content: opt.content,
    icon: 'cubeic-alert',
    confirmBtn: {
      text: opt.btnTxt || '我知道了',
    },
    onConfirm: opt.onConfirm
  }).show()
}

function getTicket (env = store.getters.env) {
  return new Promise((resolve) => {
    try {
      if (env === 'passenger') {
        window.D.bridge.call('getUserInfo', {}, function(err, ret) {
          if (err.errno * 1 !== 0) {
            showAlert(this, {txt: '获取用户信息失败，请稍后再试'})
            resolve()
          }
          resolve({
            ticket: ret.token,
            cell: ret.phone
          })
        })
      } else if (env === 'driver') {
        dbridge.getUserInfo(function (result) {
          const { ticket, phone } = result
          resolve({
            ticket,
            cell: phone
          })
        })
      } else {
        resolve()
      }
    } catch (error) {
      resolve()
    }
  })
}
// 重新登录弹窗
function reloadLogin(phone) {
  const { env } = window.GlobalSet.query
  showConfirm(this, {
    content: '为保证您的账号安全，请重新登录后再进行实名操作',
    confirmText: '重新登录',
    cancelText: '取消',
    onConfirm: () => {
      if (env === 'passenger') {
        oMegaData(name_auth_omega_summary['pub_trinity_uniid_blockshow_login_ck'], {phone})
        window.D.bridge.call('requestLogin', {
          force: false
        }, function (outerErr, outerRet) {
          console.log(outerErr, outerRet)
          window.D.bridge.call('closePage', {}, function (innerErr, innerRet) {
            console.log(innerErr, innerRet)
          })
        })
      } else if (env === 'driver') {
        oMegaData(name_auth_omega_summary['pub_trinity_uniid_blockshow_login_ck'], {phone})
        dbridge.requestLogout({
          tts: '为保证您的账号安全，请重新登录后再进行实名操作'
        })
      }
    },
    onCancel: () => {
      oMegaData(name_auth_omega_summary['pub_trinity_uniid_blockshow_cancel_ck'], {phone})
    }
  })
}

/**
 * 获取全业务线实名状态，实名冲突状态
*/
export async function getAuthStatus(ctr) {
  const { biz, ticket: ticketFromQuery, token } = window.GlobalSet.query
  let params = {
    ticket: ticketFromQuery || token || '', // 是否存在传token的情况
    biz: biz || defaultBiz() // 默认值
  }
  if (!ticketFromQuery && !token) {
    const userInfo = await getTicket()
    const { ticket } = userInfo || {}
    params.ticket = ticket
  }
  store.commit(TICKET, params.ticket)
  const requestNow = new Date() // 请求开始时间
  const res = await fetchPost({
    url: urlObj.getRealNameInfo,
    data: params,
  })
  const req_timer = new Date() - requestNow
  const { errno, data, errmsg } = res
  oMegaData(name_auth_omega_summary['pub_trinity_uniid_sw_bt'], {
    req_timer,
    errno,
    errmsg: errmsg || '出错了，请稍后重试'
  })
  if (errno * 1 === 0) {
    data && store.commit(REALNAME_VERIFY_STATUS, data)
  } else if (errno * 1 === 1015) {
    reloadLogin(params.cell)
  } else {
    showAlert(ctr, {
      content: errmsg || '出错了，请稍后重试'
    })
  }
}

export async function getUserInfo(ctr, options = {}) {
  const { biz, ticket: ticketFromQuery, token } = window.GlobalSet.query
  const _biz = biz || defaultBiz()
  let params = {
    ticket: ticketFromQuery || token || '', // 是否存在传token的情况
    biz: _biz, // 默认值
    biz_id: _biz === 'passport' ? 100 : undefined,
    fields: JSON.stringify(['name', 'cardid', 'oversea_idno'])
  }
  if (!ticketFromQuery && !token) {
    const userInfo = await getTicket()
    const { ticket } = userInfo || {}
    params.ticket = ticket
  }
  if (params.ticket) {
    store.commit(TICKET, params.ticket)
  }
  const res = await fetchPost({
    url: urlObj.getUserInfo,
    data: {
      ...params,
      ...options,
    },
  })
  const { errno, data } = res || {}
  if (Number(errno) === 0) {
    if (data) {
      store.commit(REALNAME_USER_INFO, data)
      store.commit(USER_HAS_REAL_NAME, !!data.cardid)
    }
  }
  console.log(res, 'res--------------')
}

export function waitBridgeReady () {
  return new Promise((resolve) => {
    if (window.DidiJSBridge) {
      resolve()
    } else {
      document.addEventListener('DidiJSBridgeReady', resolve)
    }
  })
}

/**
 * 获取实名展示状态Apollo
 * @param {Vue} ctr
 * @param {Object} apolloObj 请求信息
*/
export async function reanmeApolloInfo (ctr, apolloObj) {
  ctr.isReameShow = await apolloInfo({
    name: 'changename_trinity_enter',
    key: 'phone',
    phone: store.getters.cell || '',
    ...apolloObj
  })
}

/**
 * 展示冲突是否走新逻辑
 * @param {Vue} ctr
 * @param {Object} apolloObj 请求信息
*/
export async function conflictApolloInfo (ctr, apolloObj) {
  return apolloInfo({
    name: 'name_auth_conflict_show',
    key: 'phone',
    phone: store.getters.cell || '',
    ...apolloObj
  })
}

export function getBankName(comp, options = {}) {
  const { biz, ticket, token, bizId } = window.GlobalSet.query
  const baseParams = {
    ticket: ticket || token || auth.get('token'),
    biz,
    bizId,
  }
  fetchPost({
    url: urlObj.bankNameQuery,
    data: Object.assign({}, baseParams, options)
  }).then(res => {
    if (res.errno * 1 === 0) {
      comp.bankName = res.data.bank_name
      comp.showBankName = true
    } else {
      comp.showBankName = false
    }
  })
}

export function getCaptchaWithCell(comp, options = {}) {
  const { biz, ticket, token, bizId } = window.GlobalSet.query
  const baseParams = {
    ticket: ticket || token || auth.get('token'),
    biz,
    bizId,
  }
  fetchPost({
    url: urlObj.captchaWithCell,
    data: Object.assign({}, baseParams, options)
  }).then(res => {
    if (res.errno * 1 === 0) {
      comp.imgSrc = `data:image/png;base64,${res.data.img}`
    } else if (res.errno * 1 === 5003) {
      comp.alertVisible = true
      showAlert(comp, {
        content: '刷新过于频繁',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
    } else if (res.errno * 1 === 5004) {
      comp.alertVisible = true
      showAlert(comp, {
        content: '验证失败过多',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
    } else {
      comp.alertVisible = true
      showAlert(comp, {
        content: res.errmsg || '好像出错了!',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
    }
  })
}

export function getVerifyCaptchaWithCell(comp, options = {}) {
  const { biz, ticket, token, bizId } = window.GlobalSet.query
  const baseParams = {
    ticket: ticket || token || auth.get('token'),
    biz,
    bizId,
  }
  fetchPost({
    url: urlObj.verifyCaptchaWithCell,
    data: Object.assign({}, baseParams, options)
  }).then(res => {
    if (res.errno * 1 === 0) {
      comp.$router.replace({
        path: 'MergeNameInfoByBank',
        query: comp.$route.query,
      })
    } else if (res.errno * 1 === 5002) {
      comp.alertVisible = true
      showAlert(comp, {
        content: '验证码错误',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
      comp.clearCode()
    } else {
      comp.alertVisible = true
      showAlert(comp, {
        content: res.errmsg || '好像出错了!',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
      comp.clearCode()
    }
  })
}

export async function getSendSmsCode(comp, options = {}, starTimer) {
  const { biz, ticket, token, bizId } = window.GlobalSet.query
  const baseParams = {
    ticket: ticket || token || auth.get('token'),
    biz,
    bizId,
  }
  fetchPost({
    url: urlObj.sendSmsCodeWithCell,
    data: Object.assign({}, baseParams, options)
  }).then(res => {
    if (res.errno * 1 === 0) {
      // 1-语音验证码 0-短信验证码 2-邮件
      comp.verifyCodeType = res.data && res.data.code_type
      if (res.data.code_type * 1 === CODE_TYPE.SMS) {
        starTimer && starTimer()
        toast(comp, { txt:  '验证码已发送到您手机，请查收', time: 1000})
      } else if (res.data.code_type * 1 === CODE_TYPE.VOICE) {
        starTimer && starTimer()
        comp.alertVisible = true
        showAlert(comp, {
          content: '我们将给您拨打电话，通过语音播报验证码，请接听',
          onConfirm: () => {
            comp.alertVisible = false
          }
        })
      }
    } else if (res.errno * 1 === 5001) {
      comp.$router.push({
        path: 'ImgCode',
        query: {
          ...comp.$route.query,
          cell: comp.model.bank_cell
        }
      })
    } else {
      comp.alertVisible = true
      showAlert(comp, {
        content: res.errmsg || '好像出错了!',
        onConfirm: () => {
          comp.alertVisible = false
        }
      })
    }
  }).catch(() => {
    comp.isRetry = true
  })
}

export function getAuthState(_comp, options = {}) {
  const { biz, ticket, token, bizId } = window.GlobalSet.query
  const baseParams = {
    _rand: Math.floor(new Date().getTime() / 1000),
    ticket: ticket || token || auth.get('token'),
    biz: biz || defaultBiz(),
    bizId
  }
  return fetchPost({
    url: urlObj.getAuthState,
    data: Object.assign({}, baseParams, options)
  }).then((res) => {
    if (Number(res.errno) === 0) {
      _comp.AUTH_STATE(res.data)
    }
  })
}

export function initUnVerifiedRouter(_this) {
  // 不是司机端且未实名，跳转到实名认证
  const has_conflict = _this.unVerified && _this.unVerified.has_conflict
  if (!is.driver && !_this.unVerified || (!is.driver && !store.getters.getHasRealName && !has_conflict)) {
    let nameIdentityUrl;
    if (process.env.NODE_ENV === 'production') {
      nameIdentityUrl = '//page.udache.com/middle-platform/name-identity/1.1.0/index.html'
    } else {
      nameIdentityUrl = 'http://real-name-test.intra.xiaojukeji.com/name-identity/index.html'
    }
    const realNameVerifyURL = `${nameIdentityUrl}#/?biz=${defaultBiz()}&step=card&defaultSucc=self`
    url.go(realNameVerifyURL, {}, true)
    return false
  }
  if (is.driver) {
    _this.$router.replace({
      name: 'nameID',
      query: {
        type: _this.type
      }
    })
    return false
  }
  _this.$router.replace({
    // name: 'nameID',
    name: 'MergeNameInfoByBank',
    query: {
      type: _this.type
    }
  })
}
